/* eslint-disable no-control-regex */
export const validateDate = (date) => {
  const selectedDate = new Date(date);
  const now = new Date();
  
  if (isNaN(selectedDate.getTime())) {
    throw new Error('Please enter a valid date');
  }
  
  if (selectedDate < now) {
    throw new Error('Event date must be in the future');
  }
};

export const validateGuestLimit = (maxGuests) => {
  if (maxGuests) {
    const limit = parseInt(maxGuests);
    if (isNaN(limit) || limit < 1 || limit > 1000) {
      throw new Error('Guest limit must be between 1 and 1000');
    }
  }
};

export const validateDescription = (description) => {
  if (description && description.length > 5000) {
    throw new Error('Description must be between 0 and 5000 characters');
  }
};

export const validateAdditionalInfo = (additionalInfo) => {
  if (additionalInfo && additionalInfo.length > 2000) {
    throw new Error('Additional information cannot exceed 2000 characters');
  }
};